import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

import storage from './Storage'

const AutoSave = {}
const THROTTLE_EVENTS_TIMEOUT = 200
const SAVE_IN_LOCAL_STORAGE_INTERVAL = 1000
const SAVE_IN_DB_INTERVAL = 60000
let intervalId = 0

AutoSave.bind = (editorModel) => {
  AutoSave.editorModel = editorModel

  document.addEventListener('mousemove', AutoSave.save, false)
  document.addEventListener('mouseup', AutoSave.save, false)
  document.addEventListener('keyup', AutoSave.save, false)

  intervalId = setInterval(() => {
    if (
      !AutoSave.editorModel.isSaved &&
      AutoSave.editorModel.isValid &&
      // A rejected save would only be rejected again (FE-1431).
      !AutoSave.editorModel.isAutosaveBlocked
    ) {
      AutoSave.save()
      AutoSave.editorModel.save()
    }
  }, SAVE_IN_DB_INTERVAL)
}

AutoSave.save = debounce(
  throttle(() => {
    if (!AutoSave.editorModel.isSaved && AutoSave.editorModel.isValid) {
      storage.saveItem(AutoSave.editorModel.serialize())
    }
  }, SAVE_IN_LOCAL_STORAGE_INTERVAL),
  THROTTLE_EVENTS_TIMEOUT
)

AutoSave.unBind = () => {
  clearInterval(intervalId)
  document.removeEventListener('mousemove', AutoSave.save, false)
  document.removeEventListener('mouseup', AutoSave.save, false)
  document.removeEventListener('keyup', AutoSave.save, false)
}

export default AutoSave
